module.exports = __webpack_public_path__ + "assets/6b5122fa56b7d8b94b9034a27c1f2995.mp3";